import styled from 'styled-components'
import LoaderButton from 'commons/js/ui/LoaderButton'

export const SubmitButton = styled(LoaderButton)`
    padding: 8px 5px;
    height: auto;
    word-break: break-all;
`
